import React from "react";
import { Check } from "lucide-react";
import { PWA } from "@/constants/testIds";
import { WHY_POINTS } from "./data";
import Reveal from "./Reveal";

const WhyChooseUs = () => {
  return (
    <section
      id="why"
      data-testid={PWA.whySection}
      className="relative bg-[#FAF9F6] py-24 md:py-32 wood-grain"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C4033] font-semibold mb-5">
                — Why Choose Us
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif-display text-[#1A1A1A] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Built better.<br />
                <span className="italic text-[#5C4033]">On purpose.</span>
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <p className="mt-7 text-[#1A1A1A]/75 text-base md:text-lg leading-relaxed font-light max-w-md">
                Six reasons homeowners and designers across South Florida trust Precision
                with their most important pieces.
              </p>
            </Reveal>
            <Reveal delay={300}>
              <div className="mt-8 inline-block bg-[#1A1A1A] text-[#FAF9F6] px-5 py-3">
                <span className="text-[10px] tracking-[0.32em] uppercase text-[#C19A6B] font-semibold">
                  Est 2018 · South Florida
                </span>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-[#1A1A1A]/10 border border-[#1A1A1A]/10">
            {WHY_POINTS.map((p, i) => (
              <Reveal key={p.t} delay={i * 80}>
                <div className="bg-[#FAF9F6] p-7 md:p-8 h-full hover:bg-[#F1ECE0] transition-colors duration-500">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="w-9 h-9 bg-[#5C4033] text-[#FAF9F6] flex items-center justify-center">
                      <Check className="w-4 h-4" />
                    </span>
                    <span className="text-[10px] tracking-[0.32em] uppercase text-[#5C4033] font-semibold">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] leading-tight">
                    {p.t}
                  </h3>
                  <p className="mt-3 text-[#1A1A1A]/70 text-[15px] leading-relaxed font-light">
                    {p.b}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
